// Badge variants + type in a .ts (not the .svelte module script) so plain `tsc`
// can import the named `badgeVariants` value and `BadgeVariant` type.
import { type VariantProps, tv } from "tailwind-variants";

export const badgeVariants = tv({
  base: "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-full border border-transparent px-2 py-0.5 text-xs font-medium transition-colors [&>svg]:size-3 [&>svg]:pointer-events-none",
  variants: {
    variant: {
      default: "bg-brand text-on-brand",
      secondary: "bg-surface-muted text-ink",
      outline: "border-border text-ink",
      muted: "bg-surface-muted text-muted",
      "brand-soft": "border-brand-border bg-brand-soft text-brand-strong",
      success: "border-success-border bg-success-bg text-success",
      warning: "border-warning-border bg-warning-bg text-warning",
      danger: "border-danger-border bg-danger-bg text-danger",
      violet: "border-violet-border bg-violet-bg text-violet",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];
